import React from "react";
import { Form, DatePicker } from "antd";
import moment from "moment";

export default function FarmaDateTimePicker({
  getFieldDecorator,
  name,
  label = "Fecha y hora preparación",
  requiredMessage = "Campo obligatorio",
}) {
  const now = moment().seconds(0).milliseconds(0);
  const minDate = moment().subtract(72, "hours").seconds(0).milliseconds(0);

  return (
    <Form.Item label={label}>
      {getFieldDecorator(name, {
        initialValue: now,
        normalize: (value) => {
          const v = value || now;
          return v.clone().seconds(0).milliseconds(0);
        },
        rules: [
          {
            required: true,
            message: requiredMessage,
          },
        ],
      })(
        <DatePicker
          style={{ width: "100%" }}
          format="DD/MM/YYYY HH:mm"
          showTime={{ format: "HH:mm" }}
          allowClear={false}
          inputReadOnly
          onKeyDown={(e) => e.preventDefault()}
          disabledDate={(current) =>
            current &&
            (current > now.clone().endOf("minute") ||
              current < minDate.clone().startOf("minute"))
          }
          disabledTime={(current) => {
            if (!current) return {};

            const isToday = current.isSame(now, "day");
            const isMinDay = current.isSame(minDate, "day");

            return {
              disabledHours: () => {
                let hours = [];
                if (isToday) {
                  for (let h = now.hour() + 1; h <= 23; h++) hours.push(h);
                }
                if (isMinDay) {
                  for (let h = 0; h < minDate.hour(); h++) hours.push(h);
                }
                return hours;
              },
              disabledMinutes: (selectedHour) => {
                let minutes = [];

                if (isToday && selectedHour === now.hour()) {
                  for (let m = now.minute() + 1; m <= 59; m++) minutes.push(m);
                }

                if (isMinDay && selectedHour === minDate.hour()) {
                  for (let m = 0; m < minDate.minute(); m++) minutes.push(m);
                }

                return minutes;
              },
            };
          }}
        />,
      )}
    </Form.Item>
  );
}
